export const IDS = {
  appContainer: "turkbayi-app-container",
  fileInput: "excel-file-input",
  dropzone: "excel-dropzone",
  dealerSearch: "dealer-search-input",
  toggleAllDealers: "toggle-all-dealers-checkbox",
  statTotalCustomers: "stat-total-customers",
  statTotalDealers: "stat-total-dealers",
  statInliers: "stat-inliers-count",
  statOutliers: "stat-outliers-count",
  outlierSlider: "outlier-threshold-slider",
  mapContainer: "leaflet-map-container",
  fitTurkeyBounds: "map-fit-turkey-button",
  toggleCustomerDots: "toggle-customer-dots-button",
  toggleOutlierDots: "toggle-outlier-dots-button",
  exportGeojson: "export-geojson-button",
  uploadTrigger: "upload-trigger-button",
  clearData: "clear-data-button",
  dealerItem: (id) => `dealer-item-${id}`,
  dealerToggle: (id) => `dealer-toggle-${id}`,
  dealerIsolate: (id) => `dealer-isolate-${id}`,
};

export const HOME = { emergentLink: "emergent-link" };
